/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { CertonaItem } from '@/types';
import type { RecommendationItem } from '../interface';

/**
 * Transforms recommendation API response items to CertonaItem format
 * This allows existing Certona components to consume the new recommendation data
 */
export const transformRecommendations = (
  items: RecommendationItem[],
  attributionToken?: string,
): CertonaItem[] => {
  return items.map((item) => ({
    id: item.itemId,
    product_image_url: item.productImageUrl,
    product_name: item.itemDescription,
    product_url_relative: item.productDetailsPageUrl,
    average_rating: item.averageRating,
    total_review_count: item.totalReviewCount,
    attributionToken,
    // Optional fields set to defaults
    product_url: undefined,
    rating: undefined,
    isCitrusCard: false,
    agreementId: undefined,
    productId: item.itemId,
    slotNumber: undefined,
    productType: undefined,
    dssId: undefined,
    pageImpressionId: undefined,
  }));
};
